<div (window:resize)="onResize()" id="cashierAppHolder" class="quick-deposit-feature position-relative make-deposit">
    @if (redesign() && sessionInfo()) {
        <app-qd />
    }
    @if (login()) {
        <div class="error-page">
            <span class="theme-info-i"></span>
            <h3>{{ 'PARTY.CASHIER.web.deposit.session.expire.message' | translate }}</h3>
        </div>
    }

    <qd-loader />
</div>
